import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import ModalTailwind from '../../components/ModalTailwind';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle,faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';


const RegisterUser = () => {
  const { register } = useAuth();

  const [form, setForm] = useState({
    nombre: '',
    apellidos: '',
    correo: '',
    password: '',
    confirmPassword: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);



  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true); // inicia carga

    if (form.password !== form.confirmPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    try {
      await register({
        nombre: form.nombre,
        apellidos: form.apellidos,
        correo: form.correo,
        password: form.password,
        rol: 'user'
      });

      setSuccess('Usuario registrado exitosamente');
      setForm({
        nombre: '',
        apellidos: '',
        correo: '',
        password: '',
        confirmPassword: '',
      });

      setShowModal(true); // muestra modal
    } catch (err) {
      const msg = err.message || 'Error al registrar usuario';
      setError(msg);
    }

    setLoading(false); // detiene carga
  };


  return (
    <div className="min-h-screen flex justify-center items-start pt-10 relative">

       {/* Spinner de carga */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-40">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      {/* MODAL */}
      <ModalTailwind
        show={showModal}
        onClose={() => setShowModal(false)}
        title="Registro exitoso"
        onConfirm={() => setShowModal(false)}
      >
        <div className="flex items-center gap-3 mb-4 text-green-600">
          <FontAwesomeIcon icon={faCheckCircle} className="text-2xl" />
          <p className="text-sm sm:text-base">
            Registro realizado con éxito. Para iniciar sesión, primero debes verificar tu correo electrónico.
          </p>
        </div>

        <div className="flex justify-end gap-4">
          <Link
            to="/"
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Ir a inicio
          </Link>
          <Link
            to="/login"
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Iniciar sesión
          </Link>
        </div>
      </ModalTailwind>


       {/* Formulario */}
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md flex flex-col gap-4"
      >
        <h2 className="text-2xl font-semibold text-center text-blue-600">Registro de Usuario</h2>

        <input
          type="text"
          name="nombre"
          placeholder="Nombre"
          value={form.nombre}
          onChange={handleChange}
          required
          className="w-full border px-4 py-2 rounded"
        />
        <input
          type="text"
          name="apellidos"
          placeholder="Apellidos"
          value={form.apellidos}
          onChange={handleChange}
          required
          className="w-full border px-4 py-2 rounded"
        />
        <input
          type="email"
          name="correo"
          placeholder="Correo electrónico"
          value={form.correo}
          onChange={handleChange}
          required
          className="w-full border px-4 py-2 rounded"
        />
        <div className="relative">
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Contraseña"
            value={form.password}
            onChange={handleChange}
            required
            className="w-full border px-4 py-2 rounded pr-10"
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-2/4 transform -translate-y-1/2 cursor-pointer text-gray-600"
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </span>
        </div>

        <div className="relative">
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            name="confirmPassword"
            placeholder="Confirmar contraseña"
            value={form.confirmPassword}
            onChange={handleChange}
            required
            className="w-full border px-4 py-2 rounded pr-10"
          />
          <span
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            className="absolute right-3 top-2/4 transform -translate-y-1/2 cursor-pointer text-gray-600"
          >
            <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
          </span>
        </div>


          {error && <p className="text-red-500 text-center">{error}</p>}
          {/*  {success && <p className="text-green-600 text-center">{success}</p>} */}
        

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
        >
          Registrarse
        </button>

        <p className="text-center text-blue-600 mt-4">
          ¿Ya tienes cuenta?{' '}
          <Link to="/login" className="underline hover:text-blue-800">
            Inicia sesión ahora
          </Link>
        </p>

      </form>
    </div>
  );
};

export default RegisterUser;
